import { css } from 'linaria';

export const styledModal = css`
  && {
    user-select: none;
  }
`;

export const curtainMobileModal = css`
  && {
    @media (max-width: 375px) {
      && {
        border-radius: unset;
      }
    }
  }
`;

export const modalHeader = css`
  padding: 40px 64px 16px 40px;

  @media (max-width: 375px) {
    padding: 16px 48px 16px 16px;
  }
`;

export const modalHeaderTitle = css`
  @media (max-width: 375px) {
    font-size: 18px;
    line-height: 24px;
  }
`;

export const mobileHeaderTitle = css`
  @media (max-width: 375px) {
    display: none;
  }
`;

export const mobileModalHeaderTitle = css`
  display: none;

  @media (max-width: 375px) {
    display: block;
  }
`;

export const modalContentAction = css`
  padding: 40px 0;
  margin-top: auto;

  @media (max-width: 375px) {
    min-height: 80px;
    padding: 16px 0;
  }
`;
